import { Footer as MantineFooter, Text, Container } from '@mantine/core';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <MantineFooter height={40} mt="auto">
      <Container style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Text size="sm" color="dimmed">
          © {currentYear} Betfolio. All rights reserved.
        </Text>
      </Container>
    </MantineFooter>
  );
}